import { DocumentReviewReferenceDocument } from './document-review-document.entity';

export class DocumentReviewConclusion {
  constructor(data) {
    this.id = data.id;
    this.result = data.result;
    this.remark = data.remark;
    this.isEdit = data.canEdit;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.documents = data.documents ? new DocumentReviewReferenceDocument(data.documents) : null;
    this.rejectReasons = data.rejectReasons || [];
  }
}
